<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">High Performance Computing</span></p>'
      //+ '<div style="margin-left : 40px; margin-bottom: 20px"><div style="font-size: 20px;"><b style="color: #033d80; "> | </b> 简介</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:75%; height:100%;">'
      + '<p style="margin-bottom : 20px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">High Performance Computing (HPC) has been designed and constructed to meet the computing needs across SJTU since 2018. It has become one of the largest and most complete computing cores among universities in China. We have built the top 3 power- ful π2.0 supercomputer system, the most powerful AI computing system and the largest cloud computing system in China’s universities. In addition to provide computing resources, we endeavor to offer custom development and performance optimization\n' +
      'support based on user needs.</sspan></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 18px; ">联系人</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; color: #033d80; ">姓名：崔祎赟</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">邮箱：cyysjtu@sjtu.edu.cn</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">电话：17740823635</span></p>'
      + '</div>'


      + '<div id="right" style="float:left ; width:25%; height:100%;">'
      + '<p style="margin-left : 40px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/zhaojunwei.jpg" style="float: left; width: 200px; margin-right: 30px; margin-top:20px;" border="0" vspace="0" alt=""></p>'
      + '<p style="margin-left : 55px;text-align: justify"><span style="font-size: 16px;"><b>Director: Junwei Zhao</b></span></p>'
      + '</div>'
      + '<p>&nbsp;</p>'

      + '<div>'
      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;jCloud2.0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">jCloud 2.0 is equipped with 12320 CPU cores, 124TB memory, 12PB storage capacity and 100G network. We provide stable and efficient cloud host, cloud storage, dedicated VPC network, cloud database, scientific research application and other services, and cloud solutions for data and business.</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;High Performance Computing π 2.0&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">High performance computing π 2.0, double precision theoretical peak performance of 2.1 PFlops, is the first supercomputing built with Intel Cascade Lake CPU, with 656 computing nodes and a total of 26000 CPU cores. The lustre storage system based on Intel full flash NVMe SSD is used for the first time, with a storage capacity of 10PB.</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;Artificial Intelligence Computing&nbsp; </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">The artificial intelligence computing core is composed of eight DGX-2, and the in-depth learning tensor compu- ting capacity can reach 16 PFLOPS; by carrying the NVIDIA NVSwitch innovative technology, the bandwidth between GPUs is as high as 2.4 TB/s; with the scalable architecture, the complexity and scale of the model are not limited by the limitations of the traditional architecture, and meets many complex AI challenges.</span></p>'
      + '<p style="text-align: center;"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/jcloud_1_en.jpg" style="float: left; width: 800px;  " border="0" vspace="0" ></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Junwei Zhao</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: paul_zjw@sjtu.edu.cn</span></p>'

      + '</div>'

      + '<p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service9/en/index.vue